export enum ObjectState {
    Add = 0,
    Update = 1,
    Delete = 2
}
